// Which settlement worksheet rows can be edited or hidden, shared by the two
// copies of the row component: bundles/Settlement (V2 offers and independent V3
// settlements) and bundles/V3OfferPreview (pool settlements).
//
// A row is editable only if it carries an identity to persist against.
// V3SettlementOverride and V3SettlementVisibility (and their V2 counterparts)
// validate presence of overridable_id / settleable_id, so a row with a blank id
// can only ever produce "Settleable can't be blank" — offering the menu for one
// is a dead end. Keep the id guard here rather than at the request, so the
// affordance disappears instead of failing. (O-5128)

// Row types that persist as an override/visibility keyed on their own
// overridable_type + overridable_id.
export const SETTLEMENT_OVERRIDABLE_TYPES = [
  "Budget",
  "BudgetBonus",
  "BudgetLineItem",
  "EventbriteTicketClass",
  "FinanceLineItem",
  "ManualTax",
  "ManualTicketCount",
  "Offer",
  "TicketType",
  // V3-native rows. A budget line item keys to itself; a sibling guarantee
  // expense on an offer with no V2 counterpart keys to the sibling offer
  // (V3Budgets::Base#sibling_row_identity).
  "V3BudgetLineItem",
  "V3Offer",
];

// SettlementLineItem rows are edited as the record itself rather than through
// an override, so they are editable without being overridable.
const SETTLEMENT_EDITABLE_TYPES = SETTLEMENT_OVERRIDABLE_TYPES
  .concat(["SettlementLineItem"]);

export const canEditSettlementRow = (item) => {
  if (item.overridable_id === null) return false;
  if (item.overridable_id === undefined) return false;

  return SETTLEMENT_EDITABLE_TYPES.includes(item.overridable_type);
};

export const isEditingItemSettlementLineItem = (item, itemToEdit) => (
  itemToEdit
    && itemToEdit.overridable_type
    && itemToEdit.overridable_type === item.overridable_type
    && itemToEdit.overridable_id
    && itemToEdit.overridable_id === item.overridable_id
    && itemToEdit.overridable_type === "SettlementLineItem"
);

export const settlementLineItemToEdit = (item) => (
  Object.assign({}, item, {
    amount: item.amount ? parseFloat(item.amount).toFixed(2) : item.amount,
  })
);
